"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "sortNotifications", {
  enumerable: true,
  get: function get() {
    return _sortNotifications.sortNotifications;
  }
});
var _sortNotifications = require("./sort-notifications");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfc29ydE5vdGlmaWNhdGlvbnMiLCJyZXF1aXJlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL25vdGlmaWNhdGlvbi1jZW50ZXIvc29ydC1ub3RpZmljYXRpb25zL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHNvcnROb3RpZmljYXRpb25zIH0gZnJvbSAnLi9zb3J0LW5vdGlmaWNhdGlvbnMnO1xuXG5leHBvcnQgeyBzb3J0Tm90aWZpY2F0aW9ucyB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBLElBQUFBLGtCQUFBLEdBQUFDLE9BQUEifQ==